import { getCurrentUser } from '@back-office/core';
import { http } from '../config';
import {
  GET_INVITATION_LIST_ENDPOINT,
  GET_PERMISSIONS,
  INVITATIONS_ENDPOINT,
  INVITATION_CHECKING_ENDPOINT,
  REQUEST_PHONE_FOR_EMAIL,
  RESEND_INVITATION_ENDPOINT,
} from '../endpoints';
import {
  InvitationCheckingRequest,
  InvitationListResponse,
  InvitationsRequest,
  PermissionsResponse,
  SuccessResponse,
} from '../types';

export async function postInvitations(
  body: InvitationsRequest
): Promise<SuccessResponse> {
  return http.put(INVITATIONS_ENDPOINT, body, {
    skipAuthRefresh: true,
    withCredentials: false,
  });
}

export async function postCheckInvitation(
  body: InvitationCheckingRequest
): Promise<SuccessResponse> {
  return http.put(INVITATION_CHECKING_ENDPOINT, body, {
    skipAuthRefresh: true,
    withCredentials: false,
  });
}

export async function getInvitationList(): Promise<InvitationListResponse> {
  const currentUser = getCurrentUser();
  return http.get(GET_INVITATION_LIST_ENDPOINT, {
    params: { merchantID: currentUser.merchantID },
  });
}

export async function getPhoneNumber(email: string): Promise<SuccessResponse> {
  const currentUser = getCurrentUser();
  return http.post(
    `${REQUEST_PHONE_FOR_EMAIL}?merchantID=${currentUser.merchantID}`,
    { email }
  );
}
export async function postUserInvitation(
  body: InvitationsRequest
): Promise<SuccessResponse> {
  const currentUser = getCurrentUser();
  return http.put(INVITATIONS_ENDPOINT, body, {
    params: { merchantID: currentUser.merchantID },
  });
}

export async function putResendInvitation(
  body: InvitationsRequest
): Promise<SuccessResponse> {
  const currentUser = getCurrentUser();
  return http.put(RESEND_INVITATION_ENDPOINT, body, {
    params: { merchantID: currentUser.merchantID },
  });
}

export async function deleteInvitation(
  email: string
): Promise<SuccessResponse> {
  const currentUser = getCurrentUser();
  return http.delete(`${GET_INVITATION_LIST_ENDPOINT}/${email}`, {
    params: { merchantID: currentUser.merchantID },
  });
}

export async function getPermissionsList(): Promise<PermissionsResponse> {
  return http.get(`${GET_PERMISSIONS}`);
}
